import { getClientSideCookieValue } from "@/utils/common.helpers";
import { cookiesValues, DialectsEnum } from "@/constants/constants";
import { CookiesEnum } from "@/constants/constants";
import { getDefaultDialect } from "@/utils/common.helpers";
import { useEffect, useState } from "react";

export const useDialectFromClientCookies = () => {
  const [dialect, setDialect] = useState<DialectsEnum>();

  useEffect(() => {
    const dialectCookie = getClientSideCookieValue(
      cookiesValues[CookiesEnum.Dialect],
    );
    if (dialectCookie) {
      setDialect(dialectCookie as DialectsEnum);
    }
  }, []);

  return dialect;
};
